import { type Theme, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
	assign: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		[theme.breakpoints.down('md')]: {
			marginTop: 8,
		},
	},
	buttonContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	filters: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		margin: '16px 0px',
	},
}));
